import {
  CSSProperties,
  forwardRef,
  KeyboardEvent,
  ReactNode,
  RefObject,
  useEffect,
  useRef,
} from 'react'

import { mergeRefs } from '../utils/mergeRefs'
import { useClassNames } from '../utils/useClassNames'

interface PickerOverlayProps {
  className: string
  style: CSSProperties
  triggerRef: RefObject<HTMLElement>
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => void
  children: ReactNode
}

export const PickerOverlay = forwardRef<HTMLDivElement, PickerOverlayProps>(
  ({ className, style, triggerRef, onKeyDown, children }, ref) => {
    const overlayRef = useRef<HTMLDivElement>(null)
    const { merge, withClassPrefix } = useClassNames('picker-menu')

    useEffect(() => {
      const trigger = triggerRef.current
      const overlay = overlayRef.current

      if (trigger && overlay) {
        overlay.style.minWidth = `${trigger.getBoundingClientRect().width}px`
      }
    }, [triggerRef])

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        ref={mergeRefs(overlayRef, ref)}
        className={merge(className, withClassPrefix())}
        style={style}
        onKeyDown={onKeyDown}
      >
        {children}
      </div>
    )
  },
)

PickerOverlay.displayName = 'PickerOverlay'
